import React, { useState } from "react";
import Image from "next/image";
import httpClient from "@/api/http-client";
import endpoints from "@/api/endpoints";
import styles from "../../styles/shap_of_you.module.scss";
import logoabout from "../../assets/images/sph-logo.png";
import { DesktopNavigationProps } from "./types";

const AboutScreen: React.FC<DesktopNavigationProps> = ({
  navigateToStep,
  isAuthenticated,
  logStep,
}) => {
  const [loading, setLoading] = useState(false);

  // Handle "Start Experience" button click with consent checking
  const handleStartExperience = async () => {
    setLoading(true);

    // Log intro experience started
    if (logStep) {
      logStep("intro_experience_started");
    }

    try {
      if (isAuthenticated) {
        // User is authenticated - check consent status via API
        const { data } = await httpClient.get(endpoints.auth.getConsentForm());

        if (data.statusText === "accepted") {
          // Scenario 1: Consent already accepted - skip TC, go to welcome
          console.log("Consent already accepted, skipping TC screen");
          navigateToStep("welcome");
        } else {
          // Scenario 2: Consent rejected - show TC screen
          navigateToStep("tc");
        }
      } else {
        // Scenario 3: User is NOT authenticated - go to TC without API call
        navigateToStep("tc");
      }
    } catch (error) {
      console.error("Error checking consent status:", error);
      // If API fails, show TC screen anyway
      navigateToStep("tc");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="d-none d-md-block w-100">
      <section className={styles.experienceSectionDesktop}>
        <div className="d-none d-md-block w-100">
          <div className={styles.experienceCard}>
            <div className={styles.experienceContent}>
              <div className="row align-items-center">
                <div className="col-md-7">
                  {/* Video */}
                  <div className={styles.videoContainer}>
                    {/* <iframe
                      width="100%"
                      height="400"
                      src="https://www.youtube.com/embed/qm7VBAvx7U0"
                      title="Kiara Advani In Vivaha Collection '22 By Senco Gold & Diamonds"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe> */}
                    <video
                      width="100%"
                      height="auto"
                      controls
                      autoPlay={false}
                      muted
                      loop
                    >
                      <source
                        src="https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/Shape_Of_You_Story_6.mp4"
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </div>
                <div className="col-md-5">
                  {/* Text */}
                  <div className={styles.textContent}>
                    {/* Brand Logo */}
                    <div className={styles.brandLogo}>
                      <Image src={logoabout} alt="Shape of You Logo" />
                    </div>
                    <h2>Jewellery That Matches Your Face Shape</h2>

                    <p>
                      Every face tells its own story, and the jewellery you wear
                      should reflect that individuality. Understanding the shape
                      of your face is the key to selecting pieces that not only
                      complement your natural features but elevate them with
                      effortless elegance. With Shape of You, Senco&apos;s
                      innovative expert styling approach, you can now discover
                      jewellery designs tailored to your unique contours and
                      personality. From earrings that refine angles to necklaces
                      that balance proportions, each recommendation is chosen
                      with intention. Because the perfect jewellery does more
                      than accessorise - it highlights confidence, enhances
                      beauty, and above all, celebrates you.
                    </p>
                    <button
                      className={styles.ctaButton}
                      onClick={handleStartExperience}
                      disabled={loading}
                      style={
                        loading
                          ? {
                              background: "#d3d3d3",
                              color: "#888",
                              cursor: "not-allowed",
                              opacity: 0.6,
                            }
                          : {}
                      }
                    >
                      {loading ? "Loading..." : "Start Experience"}{" "}
                      {!loading && (
                        <span>
                          <svg
                            width="25"
                            height="17"
                            viewBox="0 0 30 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0.000209928 11.0458L0 8.04596H24.2579L18.3333 2.12131L20.4546 0L30.0006 9.54596L20.4546 19.092L18.3333 16.9705L24.258 11.046L0.000209928 11.0458Z"
                              fill="white"
                            />
                          </svg>
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutScreen;
